import { B2Col, B2Row } from "@hdb/biome-2";
import { FC } from "react";
import { useSelector } from "react-redux";
import SelectComponent from "../../../../shared-elements/select/select-component";

type FilterComponentType = {
  options: any;
  events: any;
  isLoading?: any;
};

const FilterComponent: FC<FilterComponentType> = ({
  options,
  events,
  isLoading,
}) => {
  const { sitesData, blocksData } = options;
  const { onChangeSiteName, onChangeBlock } = events;
  const { isLoadingFilterSitesByTCCode, isLoadingFilterBlocksBySiteCode } =
    isLoading;

  const selectedSiteCode = useSelector(
    (state: any) => state.dashboard.selectedSiteCode
  );

  const selectedBlockCode = useSelector(
    (state: any) => state.dashboard.selectedBlock
  );

  return (
    <B2Row>
      <B2Col xs={12} lg={6} className="mb-3">
        <SelectComponent
          selectedValue={selectedSiteCode}
          options={sitesData}
          placeHolder="Select Site"
          onChange={onChangeSiteName}
          isLoading={isLoadingFilterSitesByTCCode}
        />
      </B2Col>
      <B2Col xs={12} lg={6} className="mb-3">
        <SelectComponent
          selectedValue={selectedBlockCode}
          options={blocksData}
          placeHolder="Select Block"
          onChange={onChangeBlock}
          isLoading={
            isLoadingFilterSitesByTCCode || isLoadingFilterBlocksBySiteCode
          }
        />
      </B2Col>
    </B2Row>
  );
};

export default FilterComponent;
